<div
  *ngIf="alertService.alert()"
  @fadeInOut
  aria-live="assertive"
  class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-[100]"
>
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white ring-1 shadow-2xl ring-black/5">
      <div class="p-4">
        <div class="flex items-start">
          <div class="shrink-0">
            <svg class="size-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z"
              />
            </svg>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-gray-900">{{ alertService.alert()?.title }}</p>
            <p class="mt-1 text-sm text-gray-500">{{ alertService.alert()?.message }}</p>
            <div class="mt-3 flex justify-between">
              <button
                type="button"
                (click)="alertService.confirm()"
                class="rounded-md bg-white text-sm font-medium text-secondary hover:text-primary cursor-pointer"
              >
                Si
              </button>
              <button
                type="button"
                (click)="alertService.close()"
                class="rounded-md bg-white text-sm font-medium text-gray-700 hover:text-gray-500 cursor-pointer"
              >
                No
              </button>
            </div>
          </div>
          <div class="ml-4 flex shrink-0">
            <button type="button" (click)="alertService.close()" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 cursor-pointer">
              <span class="sr-only">Close</span>
              <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                <path
                  d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
